import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { Route, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-new-reset-password',
  templateUrl: './new-reset-password.component.html',
  styleUrls: ['./new-reset-password.component.scss']
})
export class NewResetPasswordComponent implements OnInit {

  resetPassword: FormGroup;
  submitted = false;
  id: any;

  constructor(
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.resetPassword = this.formBuilder.group({
      new_password: ['', [Validators.required, Validators.minLength(5)]],
      confirm_password: ['', [Validators.required, Validators.minLength(5)]]
    });

    this.route.queryParams.subscribe((res: any) => {
      console.log(res)

      this.id = res.id;
      
    });
  }

  get resetV() {
    return this.resetPassword.controls;
  }

  dismiss() {
    this.modalService.dismissAll();
  }

  reset_password() {

    
    this.submitted = true;

    if (this.resetPassword.invalid) {
      return;
    }
    
    let new_password = this.resetPassword.value.new_password;
    let confirm_password = this.resetPassword.value.confirm_password;

    if(new_password.trim() != confirm_password.trim()) {
      return this.toastr.error("Passwords do not match.");
    }

    let formData = new FormData();
    formData.append('password', confirm_password);
    formData.append('hash', this.id);
    this.auth.generate_new_password(formData).subscribe((response: any) => {
      this.modalService.dismissAll();
      this.submitted = false;
      this.resetPassword.reset();
      
      Swal.fire(
        'Success',
        'Password reset successfully.',
        'success'
      ).then(() => {
        window.location.replace(window.location.origin);
      });

    }, (e) => {
      if (e.status == 400) {
        this.toastr.error(e.error.message)
        this.modalService.dismissAll()
      }
    });
  }

}
